export class UserProfile {
  id?: number;
  token?: any;
  nbf?: number;
  exp?: number;
  name?: string;
  companyAccess?: Companies[];
  permissions?: Array<string>;
  currentCompany?: string;
  isSuperAdmin?: boolean;
  cp_access?: TokenPermissions[];
};

export class Companies {
  companyName: string;
  companyUserID: number;
  username?: string;
  hasPortalAccess?: boolean;
  hasControlPanelAccess?: boolean;
  userKey?: string;
  permissions?: Array<string>;
}

export class TokenPermissions {
  CompanyName: string;
  CompanyUserID: number;
  Permissions: Array<string>;
}
